






















































import { defineComponent, computed } from '@vue/composition-api';
import {
  SfSelect,
  SfInput,
  SfTextarea
} from '@storefront-ui/vue';

export default defineComponent({
  name: 'CustomizableOptions',
  components: {
    SfTextarea,
    SfSelect,
    SfInput
  },
  props: {
    options: {
      type: [Object, Array],
      default: null
    },
    regularPrice: {
      type: [String, Number],
      default: null
    },
    specialPrice: {
      type: [String, Number],
      default: null
    }
  },
  setup(props, context) {
    let requiredOptions = 0;

    const setValidation = () => {
      let state = false;
      props.options.forEach(option => {
        if (option.required == true) {
          state = true;
          option.selected = false;
          requiredOptions++;
        }
      });
      context.emit('validation', state);
    }
    // set validation once data is parsed
    setValidation()

    const updateProduct = (id: String, value: String, noPrice = false) => {
      if (noPrice) {
        context.emit('changeOptions', id,  value, 0);
      } else {
        const valueArray = value.split(',');
        context.emit('changeOptions', id, valueArray[0], valueArray[1]);
      }
      props.options.forEach(option => {
        if (option.option_id == id && option.selected == false) {
          option.selected = true
          requiredOptions--
        }
      });
      if (requiredOptions == 0) {
        context.emit('validation', false);
      }
    }

    const price = computed(() => props.specialPrice ? props.specialPrice : props.regularPrice);

    return {
      setValidation,
      updateProduct,
      price
    }
  },
})
